import './css-overrides.css';

import DateTime from 'react-datetime';
import DateFormat from 'dateformat';
import moment from 'moment-timezone';
import { FloatingTextInput } from '../reusable-elements/floating-text-input';

const DateTimePicker = ({ className, fetchComplete, openDtp, showTime, dateValue, placeholder, stopEditDate, setDate, editDate, children }) => {

    const { locale: myLocale } = Intl.DateTimeFormat().resolvedOptions();
    //const { timeZone: localTZ, locale: myLocale } = Intl.DateTimeFormat().resolvedOptions();

    const humanizeDate = (date) => {

        const { locale: myLocale } = Intl.DateTimeFormat().resolvedOptions();

        let format = showTime ?
            "dd/mm/yyyy HH:MM:ss" :
            "dd/mm/yyyy";

        let result = "";

        if (!date) {
            return result;
        }

        if (fetchComplete) {
            let newDate = null;
            if (date instanceof Date || typeof date === 'string') {
                const m = moment(date);
                newDate = m._a ? new Date(...m._a) : m._d;
            }
            else if (moment.isMoment(date)) {
                const local = date.local(myLocale);
                newDate = local._d ? local._d : new Date(...local._a);
            }
            if (newDate) {
                result = DateFormat(newDate, format);
            }
        }

        return result;
    }

    const localSetDate = date => {

        // console.log("TZ", moment.tz.guess());

        const day = date._d.getDate();
        const month = date._d.getMonth();
        const year = date._d.getFullYear();

        const hours = date._d.getHours();
        const minutes = date._d.getMinutes();
        const seconds = date._d.getSeconds();

        const localTime = showTime ? moment([year, month, day, hours, minutes, seconds]) : moment([year, month, day, 0, 0, 0]);
      
        setDate(localTime);

    };

    return (
        <div className={className}>
            {children}
            {openDtp ?
                <DateTime
                    className='calendar'
                    locale={myLocale}
                    open={openDtp}
                    value={dateValue}
                    dateFormat="DD/MM/YYYY"
                    timeFormat={showTime ? "HH:mm:ss" : ""}
                    inputProps={{ readOnly: true, /*placeholder: placeholder*/ value: humanizeDate(dateValue), onClick: () => stopEditDate() }}
                    onChange={e => { localSetDate(e); }}
                    onClose={e => console.log(`Close: ${e}`)}
                />
                :
                <FloatingTextInput
                    className={"mt-1 w-100"}
                    label={placeholder}
                    text={humanizeDate(dateValue)}
                    readOnly={true}
                    onClick={editDate}
                />
            }
        </div>
    );

}

export default DateTimePicker;